import { formatUser } from "../helpers/user";
import { formatClient, formatMrn } from "../helpers/episodeOfCare";
import {
  formatDate,
  formatDateOnly,
  formatTimeOnly,
  getAge
} from "../helpers/date";
export default {
  install: Vue => {
    Vue.filter("formatClient", function(data) {
      return formatClient(
        data.firstName,
        data.middleName,
        data.preferredName,
        data.lastName
      );
    });
    Vue.filter("formatClientMrn", function(data) {
      return formatClient(
        data.firstName,
        data.middleName,
        data.preferredName,
        data.lastName,
        data.mrn
      );
    });
    Vue.filter("formatMrn", function(data) {
      return formatMrn(data.mrn, data.eocn);
    });
    Vue.filter("formatDateOnly", function(data) {
      return formatDateOnly(data);
    });
    Vue.filter("formatDate", function(data) {
      return formatDate(data);
    });
    Vue.filter("formatTimeOnly", function(data) {
      return formatTimeOnly(data);
    });
    Vue.filter("getAge", function(data) {
      return getAge(data);
    });
    Vue.filter("formatUser", function(user) {
      return formatUser(user);
    });
  }
};
